import { render, staticRenderFns } from "./HomeSouscrit.vue?vue&type=template&id=31dc3820&"
import script from "./HomeSouscrit.vue?vue&type=script&lang=js&"
export * from "./HomeSouscrit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports